import { analytics } from "@/libs/telemetry"
import { getClientId } from "@/libs/telemetry/user"
import { GrowthBook } from "@growthbook/growthbook"
import { getContext } from "svelte"
import { writable } from "svelte/store"

export const contextKey = Symbol("featuresStore")

export type Features = {
  isOn: (key: string) => boolean
}

export const createFeaturesStore = (attributes: Record<string, string>) => {
  const gb = new GrowthBook({
    apiHost: __API_URL__.replace("/api", ""), // GrowthBook internally sets the /api path by default
    clientKey: __FEATURES_KEY__,
    enableDevMode: __DEV__,
    trackingCallback: (experiment, result) =>
      analytics.experiment({ id: experiment.key, variant: result.key }),
    disableCache: true,
  })

  const store = writable<{ isReady: boolean; features: Features }>({
    features: gb,
    isReady: false,
  })

  Promise.all([
    gb.setAttributes({ id: getClientId(), version: import.meta.env.VERSION, ...attributes }),
    gb.init({ streaming: false }),
  ]).finally(() => store.update((state) => ({ ...state, isReady: true })))

  return { subscribe: store.subscribe }
}

export const getFeaturesStore = () => getContext<ReturnType<typeof createFeaturesStore>>(contextKey)
